import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const COLOR = "#273A39";
const CloseTreeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none"  >
    <g opacity="0.8">
      <path d="M15 11H9V13H15V11Z" fill={props.fill || COLOR} fillOpacity="0.5" />
      <path fillRule="evenodd" clipRule="evenodd" d="M5 7C5 5.89543 5.89543 5 7 5H17C18.1046 5 19 5.89543 19 7V17C19 18.1046 18.1046 19 17 19H7C5.89543 19 5 18.1046 5 17V7ZM7 7H17V17H7V7Z" fill={props.fill || COLOR} fillOpacity="0.5" />
    </g>
  </SvgIcon>
);
CloseTreeIcon.displayName = "CloseTree";
CloseTreeIcon.muiName = "SvgIcon";

export default pure(CloseTreeIcon);